(()=>{
  const root=document.querySelector('[data-antar-home]');
  if(!root)return;
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobile=window.matchMedia('(max-width: 749px)').matches;
  const hero=root.querySelector('[data-home-hero]');
  const slides=[...root.querySelectorAll('[data-home-hero-slide]')];
  const pagination=root.querySelector('[data-home-hero-pagination]');
  const prev=root.querySelector('[data-home-hero-prev]');
  const next=root.querySelector('[data-home-hero-next]');
  const current=root.querySelector('[data-home-hero-current]');
  const total=root.querySelector('[data-home-hero-total]');
  let slideIndex=0;
  let slideTimer=null;
  const pad=n=>String(n).padStart(2,'0');
  if(total)total.textContent=pad(slides.length);

  const animate=(el,frames,options={})=>{
    if(reduce||!el?.animate)return;
    el.animate(frames,{duration:650,easing:'cubic-bezier(.22,1,.36,1)',fill:'both',...options}).finished.catch(()=>{}).then(()=>{el.getAnimations?.().forEach(animation=>animation.cancel())});
  };
  const animateHeroCopy=slide=>{
    if(reduce||!slide)return;
    [...(slide.querySelector('[data-home-hero-copy]')?.children||[])].forEach((el,index)=>{
      const frames=mobile
        ?[{transform:'translateY(12px)',filter:'blur(3px)',opacity:.25},{transform:'translateY(0)',filter:'blur(0)',opacity:1}]
        :[{transform:'translateX(-18px)',opacity:0},{transform:'translateX(0)',opacity:1}];
      animate(el,frames,{duration:560,delay:index*55});
    });
  };

  const showSlide=nextIndex=>{
    if(!slides.length)return;
    slideIndex=(nextIndex+slides.length)%slides.length;
    slides.forEach((el,i)=>el.classList.toggle('is-active',i===slideIndex));
    root.querySelectorAll('[data-home-hero-dot]').forEach((el,i)=>{
      el.classList.toggle('is-active',i===slideIndex);
      el.setAttribute('aria-current',i===slideIndex?'true':'false');
    });
    if(current)current.textContent=pad(slideIndex+1);
    animateHeroCopy(slides[slideIndex]);
  };

  if(pagination){
    pagination.innerHTML='';
    slides.forEach((slide,i)=>{
      const button=document.createElement('button');
      button.type='button';
      button.className='antar-home-hero-dot'+(i===0?' is-active':'');
      button.dataset.homeHeroDot='';
      button.dataset.index=pad(i+1);
      button.setAttribute('aria-label',`Show ${slide.dataset.slideName||`featured product ${i+1}`}`);
      button.setAttribute('aria-current',i===0?'true':'false');
      button.textContent=slide.dataset.slideName||pad(i+1);
      button.addEventListener('click',()=>{showSlide(i);restartTimer();});
      pagination.appendChild(button);
    });
  }

  const stopTimer=()=>{if(slideTimer){clearInterval(slideTimer);slideTimer=null;}};
  const startTimer=()=>{if(slides.length>1&&!reduce&&!slideTimer)slideTimer=setInterval(()=>showSlide(slideIndex+1),5200);};
  const restartTimer=()=>{stopTimer();startTimer();};
  prev?.addEventListener('click',()=>{showSlide(slideIndex-1);restartTimer();});
  next?.addEventListener('click',()=>{showSlide(slideIndex+1);restartTimer();});
  hero?.addEventListener('mouseenter',stopTimer);
  hero?.addEventListener('mouseleave',startTimer);
  hero?.addEventListener('focusin',stopTimer);
  hero?.addEventListener('focusout',e=>{if(!hero.contains(e.relatedTarget))startTimer();});
  hero?.addEventListener('keydown',e=>{
    if(e.key==='ArrowLeft'){e.preventDefault();showSlide(slideIndex-1);restartTimer();}
    if(e.key==='ArrowRight'){e.preventDefault();showSlide(slideIndex+1);restartTimer();}
  });
  document.addEventListener('visibilitychange',()=>document.hidden?stopTimer():startTimer());
  startTimer();

  const startStage=root.querySelector('[data-home-start]');
  if(startStage){
    const startCards=[...startStage.querySelectorAll('[data-start-card]')];
    const startGhost=startStage.querySelector('[data-start-ghost]');
    const startGrid=startStage.querySelector('[data-start-grid]');
    const startBreaths=[...startStage.querySelectorAll('[data-start-breath]')];
    const startWords=['CHOOSE','ENTER','RETURN'];
    if(!reduce){
      startBreaths.forEach((breath,i)=>{
        animate(breath,[
          {transform:'scale(.93)',opacity:.7,filter:'drop-shadow(0 0 0 rgba(201,169,104,0))'},
          {transform:'scale(1.055)',opacity:1,filter:'drop-shadow(0 0 12px rgba(201,169,104,.18))'},
          {transform:'scale(.96)',opacity:.78,filter:'drop-shadow(0 0 3px rgba(201,169,104,.05))'}
        ],{duration:3200+i*320,iterations:Infinity,direction:'alternate',easing:'ease-in-out'});
      });
    }
    let startIndex=0,startPathTimer=null,startVisible=false,startHeld=false,startScrollRaf=null;
    const startBackground=active=>active?'linear-gradient(145deg,rgba(201,169,104,.075),rgba(255,255,255,.018) 38%,rgba(255,255,255,.006))':'linear-gradient(160deg,rgba(255,255,255,.018),rgba(255,255,255,.006))';
    const animateSigil=(sigil,index)=>{
      if(!sigil||reduce)return;
      const outer=sigil.querySelector('[data-start-ring="outer"]');
      const inner=sigil.querySelector('[data-start-ring="inner"]');
      const dot=sigil.querySelector('[data-start-ring="dot"]');
      if(index===0){
        animate(outer,[{transform:'rotate(0deg) scale(.9)',opacity:.35},{transform:'rotate(180deg) scale(1)',opacity:1}],{duration:900});
        animate(inner,[{transform:'scale(.62)',opacity:.2},{transform:'scale(1)',opacity:1}],{duration:760});
      }else if(index===1){
        animate(outer,[{transform:'rotate(-35deg) scale(.84)',opacity:.25},{transform:'rotate(325deg) scale(1)',opacity:1}],{duration:1050});
        animate(inner,[{transform:'rotate(35deg) scale(.48)',opacity:.18},{transform:'rotate(-325deg) scale(1)',opacity:1}],{duration:980});
      }else{
        animate(outer,[{transform:'scale(.74)',opacity:.22},{transform:'scale(1.08)',opacity:1},{transform:'scale(1)',opacity:.9}],{duration:980});
        animate(inner,[{transform:'scale(1.18)',opacity:.22},{transform:'scale(.72)',opacity:1},{transform:'scale(1)',opacity:.9}],{duration:980});
      }
      animate(dot,[{transform:'translate(-50%,-50%) scale(.55)',boxShadow:'0 0 0 rgba(201,169,104,0)'},{transform:'translate(-50%,-50%) scale(1.45)',boxShadow:'0 0 30px rgba(201,169,104,.72)'},{transform:'translate(-50%,-50%) scale(1)',boxShadow:'0 0 22px rgba(201,169,104,.55)'}],{duration:820});
    };
    const renderStart=index=>{
      if(!startCards.length)return;
      startIndex=(index+startCards.length)%startCards.length;
      startCards.forEach((card,i)=>{
        const active=i===startIndex;
        card.classList.toggle('is-active',active);
        card.style.opacity=active?'1':mobile?'.78':'.62';
        card.style.transform=active?'translateY(-8px) scale(1.014)':'translateY(0) scale(1)';
        card.style.borderColor=active?'rgba(201,169,104,.58)':'rgba(216,210,196,.13)';
        card.style.boxShadow=active?'0 28px 80px rgba(0,0,0,.30),0 0 46px rgba(201,169,104,.065)':'none';
        card.style.background=startBackground(active);
        const sigil=card.querySelector('[data-start-sigil]');
        if(sigil){
          sigil.style.opacity=active?'.96':'.46';
          sigil.style.transform=active?`rotate(${i===1?12:i===2?-8:0}deg) scale(1)`:'rotate(0deg) scale(.92)';
          if(active)animateSigil(sigil,i);
        }
      });
      if(startGhost){
        startGhost.textContent=startWords[startIndex]||'';
        if(!reduce)animate(startGhost,[{transform:'translateY(13px)',filter:'blur(8px)',opacity:0},{transform:'translateY(0)',filter:'blur(0)',opacity:mobile?.012:.018}],{duration:520});
      }
    };
    const stopStartPath=()=>{if(startPathTimer){clearInterval(startPathTimer);startPathTimer=null;}};
    const startStartPath=()=>{if(startVisible&&!mobile&&!reduce&&!startHeld&&!startPathTimer&&startCards.length>1)startPathTimer=setInterval(()=>renderStart(startIndex+1),2700);};
    startCards.forEach((card,i)=>{
      card.addEventListener('pointerenter',()=>{if(!mobile){startHeld=true;stopStartPath();renderStart(i);}});
      card.addEventListener('pointermove',event=>{
        if(mobile)return;
        const rect=card.getBoundingClientRect();
        const x=Math.max(0,Math.min(100,((event.clientX-rect.left)/rect.width)*100));
        const y=Math.max(0,Math.min(100,((event.clientY-rect.top)/rect.height)*100));
        card.style.background=`radial-gradient(circle at ${x}% ${y}%,rgba(201,169,104,.115),transparent 34%),${startBackground(i===startIndex)}`;
      });
      card.addEventListener('pointerleave',()=>{card.style.background=startBackground(i===startIndex);if(!mobile){startHeld=false;startStartPath();}});
      card.addEventListener('focus',()=>{startHeld=true;stopStartPath();renderStart(i);});
      card.addEventListener('blur',()=>{startHeld=false;startStartPath();});
      card.addEventListener('pointerdown',event=>{if(mobile&&event.pointerType!=='mouse')renderStart(i);},{passive:true});
      card.addEventListener('click',()=>renderStart(i));
    });
    if(mobile&&startGrid){
      startGrid.addEventListener('scroll',()=>{
        if(startScrollRaf)cancelAnimationFrame(startScrollRaf);
        startScrollRaf=requestAnimationFrame(()=>{
          const center=startGrid.getBoundingClientRect().left+startGrid.clientWidth/2;
          let nearest=0,distance=Infinity;
          startCards.forEach((card,i)=>{const rect=card.getBoundingClientRect();const d=Math.abs(rect.left+rect.width/2-center);if(d<distance){distance=d;nearest=i;}});
          if(nearest!==startIndex)renderStart(nearest);
        });
      },{passive:true});
    }
    if('IntersectionObserver'in window){
      const startObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
        startVisible=entry.isIntersecting;
        if(startVisible){startStage.dataset.startVisible='true';startStartPath();}
        else stopStartPath();
      }),{threshold:.24});
      startObserver.observe(startStage);
    }else{startVisible=true;startStartPath();}
    renderStart(0);
  }



  const railStates=[...root.querySelectorAll('[data-product-rail]')].map(stage=>{
    const track=stage.querySelector('[data-product-rail-track]');
    const originals=track?[...track.querySelectorAll(':scope > [data-product-rail-card]')]:[];
    const currentEl=stage.querySelector('[data-product-rail-current]');
    const totalEl=stage.querySelector('[data-product-rail-total]');
    const nextButton=stage.querySelector('[data-product-rail-next]');
    if(!track||!originals.length)return null;
    originals.forEach(card=>{
      const clone=card.cloneNode(true);
      clone.dataset.productRailClone='true';
      clone.classList.remove('is-active');
      track.appendChild(clone);
    });
    const cards=[...track.querySelectorAll(':scope > [data-product-rail-card]')];
    const count=originals.length;
    let physicalIndex=0,timer=null,scrollRaf=null,settleTimer=null;
    if(totalEl)totalEl.textContent=pad(count);
    const copyIsRight=stage.dataset.railSide==='left';
    const trackStyle=getComputedStyle(track);
    const edgePadding=copyIsRight?(parseFloat(trackStyle.paddingRight)||0):(parseFloat(trackStyle.paddingLeft)||0);
    const maxScroll=()=>Math.max(0,track.scrollWidth-track.clientWidth);
    const targetScroll=index=>{
      const card=cards[index];if(!card)return 0;
      const raw=copyIsRight?card.offsetLeft+card.offsetWidth+edgePadding-track.clientWidth:card.offsetLeft-edgePadding;
      return Math.max(0,Math.min(raw,maxScroll()));
    };
    const render=index=>{
      physicalIndex=Math.max(0,Math.min(index,cards.length-1));
      cards.forEach((card,i)=>card.classList.toggle('is-active',i===physicalIndex));
      if(currentEl)currentEl.textContent=pad((physicalIndex%count)+1);
    };
    const jumpTo=index=>{
      const nextIndex=Math.max(0,Math.min(index,cards.length-1));
      const previousBehavior=track.style.scrollBehavior;
      track.style.scrollBehavior='auto';track.scrollLeft=targetScroll(nextIndex);render(nextIndex);
      requestAnimationFrame(()=>{track.style.scrollBehavior=previousBehavior;});
    };
    const goTo=index=>{const nextIndex=Math.max(0,Math.min(index,cards.length-1));render(nextIndex);track.scrollTo({left:targetScroll(nextIndex),behavior:reduce?'auto':'smooth'});};
    const advance=()=>{
      if(copyIsRight){if(physicalIndex>=cards.length-1)jumpTo(count-1)}else if(physicalIndex>=count)jumpTo(physicalIndex-count);
      goTo(physicalIndex+1);
    };
    const syncFromScroll=()=>{
      const anchor=copyIsRight?track.scrollLeft+track.clientWidth-edgePadding:track.scrollLeft+edgePadding;
      let nearest=0,distance=Infinity;
      cards.forEach((card,i)=>{const edge=copyIsRight?card.offsetLeft+card.offsetWidth:card.offsetLeft;const d=Math.abs(edge-anchor);if(d<distance){distance=d;nearest=i;}});
      render(nearest);clearTimeout(settleTimer);
      settleTimer=setTimeout(()=>{if(copyIsRight&&physicalIndex<count)jumpTo(physicalIndex+count);if(!copyIsRight&&physicalIndex>=count)jumpTo(physicalIndex-count);},180);
    };
    const stop=()=>{if(timer){clearInterval(timer);timer=null;}};
    const start=()=>{if(!reduce&&count>1&&!timer)timer=setInterval(advance,mobile?6500:5600);};
    const restart=()=>{stop();start();};
    nextButton?.addEventListener('click',()=>{advance();restart();});
    track.addEventListener('scroll',()=>{if(scrollRaf)cancelAnimationFrame(scrollRaf);scrollRaf=requestAnimationFrame(syncFromScroll);},{passive:true});
    stage.addEventListener('mouseenter',stop);stage.addEventListener('mouseleave',start);stage.addEventListener('focusin',stop);stage.addEventListener('focusout',e=>{if(!stage.contains(e.relatedTarget))start();});
    track.addEventListener('pointerdown',stop,{passive:true});track.addEventListener('pointerup',()=>setTimeout(start,1800),{passive:true});
    requestAnimationFrame(()=>jumpTo(copyIsRight?count:0));start();
    return{stage,track,copyIsRight};
  }).filter(Boolean);

  const touchLayout=window.matchMedia?.('(max-width: 820px)').matches;
  const bindMobileHoverRail=(track,itemSelector)=>{
    if(!touchLayout||!track)return;
    const items=()=>[...track.querySelectorAll(itemSelector)];
    let frame=0;
    const clearActive=()=>items().forEach(item=>item.classList.remove('is-mobile-active'));
    const sync=()=>{
      frame=0;
      const cards=items();
      if(!cards.length||track.scrollWidth<=track.clientWidth+4){clearActive();return;}
      const trackRect=track.getBoundingClientRect();
      if(trackRect.bottom<=0||trackRect.top>=window.innerHeight){clearActive();return;}
      const leftEdge=Math.max(0,trackRect.left);
      const rightEdge=Math.min(window.innerWidth,trackRect.right);
      let winner=null;
      let best=-1;
      cards.forEach(card=>{
        const rect=card.getBoundingClientRect();
        const visible=Math.max(0,Math.min(rect.right,rightEdge)-Math.max(rect.left,leftEdge));
        const ratio=visible/Math.max(1,rect.width);
        if(ratio>best){best=ratio;winner=card;}
      });
      cards.forEach(card=>card.classList.toggle('is-mobile-active',card===winner&&best>.18));
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(sync);};
    track.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    items().forEach(item=>{
      item.addEventListener('pointerdown',event=>{
        if(event.pointerType==='mouse'||track.scrollWidth<=track.clientWidth+4)return;
        items().forEach(card=>card.classList.remove('is-mobile-active'));
        item.classList.add('is-mobile-active','is-mobile-pressed');
      },{passive:true});
      const release=()=>{item.classList.remove('is-mobile-pressed');schedule();};
      item.addEventListener('pointerup',release,{passive:true});
      item.addEventListener('pointercancel',release,{passive:true});
      item.addEventListener('pointerleave',release,{passive:true});
    });
    requestAnimationFrame(sync);
  };
  [
    ['.antar-home-start-grid','.antar-home-start-card'],
    ['.antar-home-collections','.antar-home-collection-card'],
    ['.antar-home-namastra-track','.antar-home-namastra-card'],
    ['.antar-home-mala-track','.antar-home-mala-card'],
    ['.antar-home-products','.antar-home-product'],
    ['.antar-home-community-grid','.antar-home-community-image'],
    ['.antar-footer-path-grid','.antar-footer-path-card']
  ].forEach(([trackSelector,itemSelector])=>root.querySelectorAll(trackSelector).forEach(track=>bindMobileHoverRail(track,itemSelector)));

  const observeOnce=(elements,callback,{rootMargin='0px 0px -8% 0px',threshold=.08}={})=>{
    const list=[...elements].filter(Boolean);
    if(reduce||!('IntersectionObserver'in window)){list.forEach(callback);return;}
    const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){callback(entry.target);io.unobserve(entry.target);}}),{rootMargin,threshold});
    list.forEach(el=>io.observe(el));
  };

  animateHeroCopy(slides[0]);
  observeOnce(root.querySelectorAll('[data-home-reveal]'),el=>animate(el,[{transform:'translateY(28px)',opacity:0},{transform:'translateY(0)',opacity:1}],{duration:760}));
  observeOnce(root.querySelectorAll('[data-home-card]'),el=>animate(el,[{transform:'translateY(30px)',opacity:0},{transform:'translateY(0)',opacity:1}],{duration:720}));
  observeOnce(root.querySelectorAll('[data-home-product]'),el=>animate(el,[{transform:'translateY(22px)',opacity:0},{transform:'translateY(0)',opacity:1}],{duration:620}));
  observeOnce(root.querySelectorAll('[data-home-feature]'),el=>{
    const copy=el.querySelector('.antar-home-feature-copy,.antar-home-seasonal-copy,.antar-home-closing-inner');
    const media=el.querySelector('.antar-home-feature-media img,.antar-home-seasonal-media img');
    if(copy)animate(copy,[{transform:`translateY(${mobile?16:28}px)`,opacity:0},{transform:'translateY(0)',opacity:1}],{duration:760});
    if(media)animate(media,[{transform:mobile?'translateY(18px)':'scale(1.045)',opacity:mobile ? .55 : 1},{transform:mobile?'translateY(0)':'scale(1)',opacity:1}],{duration:900});
  });
  railStates.forEach(({stage,track,copyIsRight})=>{if(!mobile)observeOnce([stage],()=>animate(track,[{transform:`translateX(${copyIsRight?-90:90}px)`},{transform:'translateX(0)'}],{duration:900}));});


})();
